/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Direkt/theme';

export const DirektTheme = theme;
